// Simple utility to generate IDs that are unique to the page.
// From http://stackoverflow.com/questions/29420835/how-to-generate-unique-ids-for-form-labels-in-react

let lastId = 0;

export default function uniqueId(prefix='id') {
    lastId++;
    return `${prefix}${lastId}`;
}
